import * as React from "react";
import { Modal, Form, Button } from "antd";
import CopyFormTypeForm, { CopyFormTypeFormProps } from "./CopyFormTypeForm";

export interface State {}

export interface Props {
  newFormVersionModalVisible?: boolean;
  hideNewFormVersionModal: () => void;
  translate: any;
  rowData: any;
  createNewFormVersion: any;
}

export default class NewFormVersionDialog extends React.Component<
  Props,
  State
> {
  private formSubmitHandler: any;

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.registerFormSubmitEventHandler = this.registerFormSubmitEventHandler.bind(
      this
    );
  }

  registerFormSubmitEventHandler(registrationHandler) {
    this.formSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const { createNewFormVersion, hideNewFormVersionModal } = this.props;
    if (this.formSubmitHandler) {
      let newData = this.formSubmitHandler(e);
      if (newData) {
        createNewFormVersion(newData.oldCode, newData);
        hideNewFormVersionModal();
      }
    }
  }

  render() {
    const {
      newFormVersionModalVisible,
      hideNewFormVersionModal,
      translate,
      rowData,
      createNewFormVersion
    } = this.props;

    const FormTypeCopy = Form.create<CopyFormTypeFormProps>({})(
      CopyFormTypeForm
    );

    return (
      <Modal
        title={translate("new_version_modal.title")}
        maskClosable={false}
        visible={newFormVersionModalVisible}
        onCancel={hideNewFormVersionModal}
        onOk={this.onSubmit}
        footer={[
          <Button key="back" onClick={hideNewFormVersionModal}>
            {translate("new_version_modal.cancel")}
          </Button>,
          <Button key="submit" type="primary" onClick={this.onSubmit}>
            {translate("new_version_modal.create")}
          </Button>
        ]}
      >
        <FormTypeCopy
          translate={translate}
          rowData={rowData}
          copyFormType={createNewFormVersion}
          registerFormSubmitEventHandler={this.registerFormSubmitEventHandler}
        ></FormTypeCopy>
      </Modal>
    );
  }
}
